import { Grid, Typography } from '@mui/material';
import { ML_QC_OPTIONS_RECORDS } from 'components/QCViewer/constants';
import React from 'react';
import { QCReasonCheckbox } from 'components/Modals/QCPassFailModal/QCReasonCheckbox';

export const FailFormInputs = ({
  classes,
  slide,
  qcChecks,
  setQCChecks,
  currentQcScoreDisplay,
  setCurrentQcScoreDisplay,
  isGLP,
}) => {
  const handleCheckboxChanged = (optionName) => (e, value) => {
    setQCChecks((prevState) => ({
      ...prevState,
      [optionName]: value,
    }));
  };

  const handleModelOverlayClick = (optionName) => (isEnabled) => {
    const optionToSet = isEnabled ? null : optionName;
    setCurrentQcScoreDisplay(optionToSet);
  };

  return (
    <>
      <Typography variant={'subtitle1'} color={'inherit'}>
        <b>Check All That Apply:</b>
      </Typography>
      <Grid container spacing={1}>
        {ML_QC_OPTIONS_RECORDS.map((option) => (
          <Grid item key={option.attribute} xs={6}>
            <QCReasonCheckbox
              classes={classes}
              check={qcChecks[option.attribute]}
              label={option.label}
              handleCheckboxChanged={handleCheckboxChanged(option.attribute)}
              qcScore={slide[option.scoreAttribute]}
              isModelOverlayEnabled={
                currentQcScoreDisplay === option.dataAttribute
              }
              handleModelOverlayClick={handleModelOverlayClick(
                option.dataAttribute,
              )}
              qcData={slide.additional_data?.[option.dataAttribute]}
              isGLP={isGLP}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
